export default {
  WriteCredential:function(data){
      localStorage.setItem('AuthenticationToken',JSON.stringify(data))
  },
  GetCredential:function(){
    var Credential = localStorage.getItem('AuthenticationToken')
    if(Credential === null || Credential === "" || Credential === undefined){
      return{
          username: null,
          token: null,
          refresh_token: null,
          is_auth :false,
          in_auth : false,
          props:{
              alias:null,
              email:null,
              phone:null,
              first_name:null,
              last_name:null, 
              tag:null,
              role:null,
              address1:null,
              address2:null,
              city:null,
              postal:null,
              permission:null,
              isAdmin:null,
              is_superuser:null,
              isStorage:null,
              emailNotif:null,
          }
      }
    }
    return JSON.parse(Credential)

    //for Refresh Token Testing
    // Credential = JSON.parse(Credential)
    // Credential.token = 'RoKnQGwJyFQ5hdHH8Atb4xYQdN1AqQ'
    // return Credential

  },
  RemoveCredential : function(){
    localStorage.removeItem('AuthenticationToken');
  }
}



// WEBPACK FOOTER //
// ./src/App/user/auth.js